import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M45 20.6V3c0-1.7-1.3-3-3-3H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V24.4H24.4l-3.3-1.9 3.3-1.9H45zm-21.9-2.2l-3.3 1.9-1.6.9H16l-2.5-2.5-1.8 1.8 3.3 3.3h3.3l1.6.9 3.3 1.9.6.3h18.8V42c0 .3-.2.5-.5.5H3c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h39c.3 0 .5.2.5.5v15.1H23.7l-.6.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M34 4.6c-3.1 0-5.7 2.6-5.7 5.7S30.8 16 34 16s5.7-2.6 5.7-5.7-2.6-5.7-5.7-5.7zm0 8.9c-1.8 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2 3.2 1.4 3.2 3.2-1.4 3.2-3.2 3.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M34 40.4c3.1 0 5.7-2.6 5.7-5.7S37.1 29 34 29s-5.7 2.6-5.7 5.7 2.5 5.7 5.7 5.7zm0-8.9c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.2-1.4-3.2-3.2 1.4-3.2 3.2-3.2z"
		})
	] }), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M16.9 34.7c-6.7 0-12.2-5.5-12.2-12.2 0-6.7 5.5-12.2 12.2-12.2s12.2 5.5 12.2 12.2c0 6.7-5.5 12.2-12.2 12.2zm0-21.9c-5.4 0-9.7 4.4-9.7 9.7 0 5.4 4.4 9.7 9.7 9.7 5.4 0 9.7-4.4 9.7-9.7 0-5.3-4.3-9.7-9.7-9.7z"
	})]
});
export default SvgIcon;
